import * as L from 'leaflet';
import 'mapbox-gl-leaflet';

import { Children, MapLayer, withLeaflet } from 'react-leaflet';

export interface IMapboxGLProps extends L.MapboxGLOptions {
  children?: Children;
}

class MapBoxGLLayer extends MapLayer<IMapboxGLProps, {}> {
  protected static defaultProps = {
    style: 'mapbox://styles/mapbox/streets-v9',
  };

  public createLeafletElement(props: IMapboxGLProps) {
    return L.mapboxGL(props);
  }

  public render() {
    return null;
  }
}

export default withLeaflet(MapBoxGLLayer);
